import { put } from 'redux-saga/effects'
import { Game } from '../../Core'

import EndSessionScreen from './EndSessionScreen'
import FinishedGamePopUp from './FinishedGamePopUp'

/**
 *  Init module.
 */
function* init() {
  yield loadComponents()
}
/**
 * Load components.
 */
export function* loadComponents() {
  const components = {
    EndSessionScreen,
    FinishedGamePopUp,
  }

  yield put(Game.actions.registerComponents(components))
}

/**
  END TURN
*/
export function* startEnd() {
  yield put(Game.actions.startSceneChange('endTurnScene'))
}

/**
 * Sagas entrypoint.
 */
export function* sagas() {
  yield init()
}
